import React, { useState } from 'react';

const EC = {
  disponible:{fill:'#0055a5',hover:'#003d7a'},
  vendido:   {fill:'#94a3b8',hover:'#64748b'},
  reservado: {fill:'#f97316',hover:'#ea6c0a'},
};

const INFO_101 = {
  1:  {n:1, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  2:  {n:2, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  3:  {n:3, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  4:  {n:4, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  5:  {n:5, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  6:  {n:6, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  7:  {n:7, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  8:  {n:8, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  9:  {n:9, s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  10: {n:10,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  11: {n:11,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  12: {n:12,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  13: {n:13,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  14: {n:14,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  15: {n:15,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  16: {n:16,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  17: {n:17,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  18: {n:18,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  19: {n:19,s:312.50, p:24000, d:'Vista al Mar',  e:'disponible'},
  20: {n:20,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  21: {n:21,s:312.50, p:24000, d:'Vista al Mar',  e:'disponible'},
  22: {n:22,s:312.50, p:24000, d:'Vista al Mar',  e:'disponible'},
  23: {n:23,s:312.50, p:24000, d:'Vista al Mar',  e:'disponible'},
  24: {n:24,s:318.52, p:24000, d:'Vista al Mar',  e:'disponible'},
  25: {n:25,s:396.39, p:27000, d:'Vista al Mar',  e:'disponible'},
  26: {n:26,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  27: {n:27,s:300.00, p:20500, d:'Vista al Mar',  e:'disponible'},
  28: {n:28,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  29: {n:29,s:300.00, p:20500, d:'Vista al Mar',  e:'disponible'},
  30: {n:30,s:318.70, p:20500, d:'Vista al Mar',  e:'disponible'},
  31: {n:31,s:408.41, p:null,  d:'Vista al Mar',  e:'vendido'},
  32: {n:32,s:678.62, p:null,  d:'Vista al Mar',  e:'vendido'},
  33: {n:33,s:395.58, p:null,  d:'Vista al Mar',  e:'vendido'},
  34: {n:34,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  35: {n:35,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  36: {n:36,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  37: {n:37,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  38: {n:38,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  39: {n:39,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  40: {n:40,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  41: {n:41,s:307.27, p:null,  d:'Vista al Mar',  e:'vendido'},
  42: {n:42,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  43: {n:43,s:312.00, p:null,  d:'Vista al Mar',  e:'vendido'},
  44: {n:44,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  45: {n:45,s:300.10, p:24000, d:'Vista al Mar',  e:'disponible'},
  46: {n:46,s:null,   p:null,  d:'Vista al Mar',  e:'vendido'},
  47: {n:47,s:362.91, p:48000, d:'Vista al Mar',  e:'disponible'},
  48: {n:48,s:356.00, p:48000, d:'Vista al Mar',  e:'disponible'},
};

function Modal({lote, onClose, onConsultar}) {
  React.useEffect(() => {
    const h = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);
  return (
    <div className='fixed inset-0 z-[200] flex items-center justify-center p-4'
      style={{backgroundColor:'rgba(0,0,0,0.6)',backdropFilter:'blur(6px)'}} onClick={onClose}>
      <div className='bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden'
        style={{animation:'popIn 0.28s cubic-bezier(0.34,1.56,0.64,1) both'}} onClick={e=>e.stopPropagation()}>
        <div className='bg-[#0055a5] px-7 py-5 text-white relative'>
          <button onClick={onClose} className='absolute top-3 right-4 text-2xl font-bold opacity-50 hover:opacity-100'>x</button>
          <p className='text-[10px] uppercase tracking-[0.3em] opacity-60 mb-1'>Manzana 101</p>
          <h3 className='text-3xl font-black'>Parcela {lote.n}</h3>
          <span className='inline-block mt-2 text-[10px] font-black uppercase px-3 py-1 rounded-full bg-white/20'>
            {lote.e==='disponible'?'Disponible':lote.e==='reservado'?'Reservado':'Vendido'}
          </span>
        </div>
        <div className='p-5 grid grid-cols-2 gap-3'>
          <div className='bg-slate-50 rounded-2xl p-4'>
            <p className='text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1'>Superficie</p>
            <p className='text-2xl font-black text-slate-800'>{lote.s ? `${lote.s}` : '-'}<span className='text-sm font-normal text-slate-400'> m²</span></p>
          </div>
          <div className='bg-slate-50 rounded-2xl p-4'>
            <p className='text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1'>Precio</p>
            <p className='text-xl font-black' style={{color:lote.e==='disponible'?'#0055a5':'#94a3b8'}}>
              {lote.e==='disponible'&&lote.p ? 'USD '+lote.p.toLocaleString() : <span className='text-base'>-</span>}
            </p>
          </div>
          <div className='bg-slate-50 rounded-2xl p-4 col-span-2'>
            <p className='text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1'>Ubicación</p>
            <p className='text-base font-semibold text-slate-700'>{lote.d}</p>
          </div>
        </div>
        <div className='px-5 pb-5'>
          {lote.e==='disponible'
            ? <button onClick={onConsultar} className='w-full bg-[#0055a5] text-white py-4 rounded-2xl font-black uppercase tracking-widest text-sm hover:bg-blue-700 active:scale-95 transition-all'>Consultar este lote</button>
            : <p className='text-center text-slate-400 text-sm py-2'>{lote.e==='vendido'?'Este lote fue vendido.':'Este lote está reservado.'}</p>}
        </div>
      </div>
      <style>{'@keyframes popIn{from{opacity:0;transform:scale(0.8) translateY(20px)}to{opacity:1;transform:scale(1) translateY(0)}}'}</style>
    </div>
  );
}

function getCentroid101(pts) {
  const nums = pts.trim().split(/\s+/).map(Number);
  let x = 0, y = 0;
  const count = nums.length / 2;
  for (let i = 0; i < nums.length; i += 2) { x += nums[i]; y += nums[i+1]; }
  return [x / count, y / count];
}

function Parcel({id, points, d, num, hov, setHov, onClick}) {
  const lote = INFO_101[num];
  if (!lote) return null;
  const estado = lote.e;
  const fill = hov === id ? EC[estado].hover : EC[estado].fill;
  const isClickable = estado !== 'vendido';
  const shapeProps = {
    id, fill, stroke:'white', strokeWidth:2,
    style: isClickable ? {cursor:'pointer'} : {},
    onMouseEnter: isClickable ? () => setHov(id) : undefined,
    onMouseLeave: isClickable ? () => setHov(null) : undefined,
    onClick: isClickable ? () => onClick(lote) : undefined,
  };
  if (points) return <polygon {...shapeProps} points={points}/>;
  if (d) return <path {...shapeProps} d={d}/>;
  return null;
}

export default function Manzana101SVG() {
  const [hov, setHov] = useState(null);
  const [modal, setModal] = useState(null);

  const handleConsultar = () => {
    if (modal) {
      window.dispatchEvent(new CustomEvent('seleccionarLote', {
        detail: { manzana: '101', lote: modal.n }
      }));
    }
    setModal(null);
    setTimeout(() => document.getElementById('contacto')?.scrollIntoView({behavior:'smooth'}), 150);
  };

  const disp = Object.values(INFO_101).filter(l=>l.e==='disponible').length;
  const vend = Object.values(INFO_101).filter(l=>l.e==='vendido').length;

  return (
    <div>
      <div className='mb-4'>
        <div className='flex flex-wrap items-center gap-3 mb-1'>
          <h3 className='text-lg font-black text-[#0055a5] uppercase tracking-wide'>Manzana 101 - Premium</h3>
          <span className='text-xs font-bold px-3 py-1 rounded-full bg-blue-50 text-[#0055a5]'>{disp} disponibles</span>
          <span className='text-xs font-bold px-3 py-1 rounded-full bg-slate-100 text-slate-500'>{vend} vendidos</span>
        </div>
        <p className='text-sm text-slate-400'>Hacé click en cualquier lote para ver los detalles.</p>
      </div>
      <div className='flex flex-wrap gap-4 mb-4'>
        {[['disponible','#0055a5'],['reservado','#f97316'],['vendido','#94a3b8']].map(([k,c])=>(
          <div key={k} className='flex items-center gap-2'>
            <span className='w-3.5 h-3.5 rounded-sm' style={{backgroundColor:c,display:'inline-block'}}/>
            <span className='text-xs font-semibold text-slate-500 capitalize'>{k}</span>
          </div>
        ))}
      </div>
      <div className='bg-[#f8fafc] rounded-2xl border border-stone-100 overflow-hidden p-2'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1280' className='w-full h-auto' style={{maxHeight:580}}>
          <Parcel id='101-1'  num={1}  points='365.90 239.42 340.93 261.54 392.55 322.19 418.59 298.90 367.96 239.42' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-2'  num={2}  points='418.59 298.90 353.22 357.39 376.81 383.44 442.67 324.95 418.59 298.90' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-3'  num={3}  points='442.67 324.95 472.03 358.00 403.84 416.37 376.81 383.44 442.67 324.95' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-4'  num={4}  points='502.16 388.34 473.03 357.00 404.84 415.37 434.83 447.32 502.16 388.34' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-5'  num={5}  points='531.15 425.71 501.16 389.34 433.83 448.32 461.61 480.04 531.15 425.71' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-6'  num={6}  points='559.65 458.15 531.15 425.71 461.61 480.04 490.84 514.18 559.65 458.15' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-7'  num={7}  points='589.64 490.10 559.65 458.15 490.84 514.18 518.97 548.72 589.64 490.10' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-8'  num={8}  points='617.65 523.03 589.64 490.10 518.97 548.72 550.81 582.01 617.65 523.03' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-9'  num={9}  points='646.16 555.47 617.65 523.03 550.81 582.01 579.60 614.64 646.16 555.47' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-10' num={10} points='676.15 588.89 646.16 555.47 579.60 614.64 607.12 645.61 676.15 588.89' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-11' num={11} points='703.67 620.35 676.15 588.89 607.12 645.61 639.28 680.32 703.67 620.35' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-12' num={12} points='735.62 657.71 703.67 620.35 639.28 680.32 667.30 715.22 735.62 657.71' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-13' num={13} points='767.09 691.62 735.62 657.71 667.30 715.22 700.23 750.11 767.09 691.62' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-14' num={14} points='792.15 718.66 767.09 691.62 700.23 750.11 737.37 792.57 792.15 737.83 792.15 718.66' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-15' num={15} points='708.10 822.86 737.37 792.57 685.95 734.98 653.04 769.78 708.10 822.86' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-16' num={16} points='679.10 851.37 708.10 822.86 653.04 769.78 625.53 798.31 679.10 851.37' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-17' num={17} points='653.04 880.37 679.10 851.37 625.53 798.31 597.16 826.95 653.04 880.37' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-18' num={18} points='622.08 909.86 653.04 880.37 597.16 826.95 570.24 855.12 622.08 909.86' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-19' num={19} points='597.16 938.37 622.08 909.86 570.24 855.12 541.47 886.76 597.16 938.37' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-20' num={20} points='567.52 968.84 597.16 938.37 541.47 886.76 515.18 915.12 567.52 968.84' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-21' num={21} points='539.01 997.35 567.52 968.84 515.18 915.12 485.12 944.41 539.01 997.35' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-22' num={22} points='512.00 1027.82 539.01 997.35 485.12 944.41 458.89 974.25 512.00 1027.82' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-23' num={23} points='485.12 1055.35 512.00 1027.82 458.89 974.25 432.24 1000.67 485.12 1055.35' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-24' num={24} points='462.82 1077.47 485.12 1055.35 432.24 1000.67 410.76 1021.44 435.30 1077.47 462.82 1077.47' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-25' num={25} points='385.16 956.24 410.76 1021.44 458.89 974.25 405.07 919.95 388.60 938.37 385.16 956.24' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-26' num={26} points='428.42 894.62 405.07 919.95 458.89 974.25 485.12 944.41 428.42 894.62' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-27' num={27} points='458.89 863.66 428.42 894.62 485.12 944.41 509.00 917.21 458.89 863.66' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-28' num={28} points='485.12 837.61 458.89 863.66 509.00 917.21 539.01 889.13 485.12 837.61' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-29' num={29} points='512.00 807.62 485.12 837.61 539.01 889.13 564.94 860.95 512.00 807.62' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-30' num={30} points='535.57 782.06 512.00 807.62 564.94 860.95 597.16 826.95 535.57 782.06' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-31' num={31} points='556.17 758.96 535.57 782.06 597.16 826.95 647.62 774.16 556.17 758.96' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-32' num={32} points='559.65 727.50 556.17 758.96 647.62 774.16 683.52 734.98 647.62 695.56 559.65 727.50' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-33' num={33} points='546.88 703.91 559.65 727.50 647.62 695.56 607.12 649.84 546.88 703.91' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-34' num={34} points='525.03 675.40 546.88 701.45 607.12 647.88 585.71 621.51 525.03 675.40' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-35' num={35} points='501.16 649.84 525.03 675.40 583.74 621.51 559.65 596.93 501.16 649.84' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-36' num={36} points='478.55 624.28 501.16 649.84 559.65 596.93 535.62 570.36 478.55 624.28' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-37' num={37} points='454.47 596.93 478.55 624.28 535.62 570.36 512.00 545.36 454.47 596.93' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-38' num={38} points='430.88 568.84 454.47 596.93 512.00 545.36 490.84 517.62 430.88 568.84' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-39' num={39} points='407.28 541.71 430.88 568.84 490.84 517.62 467.33 490.10 407.28 541.71' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-40' num={40} points='384.18 514.18 407.28 541.71 467.33 490.10 442.67 461.40 384.18 514.18' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-41' num={41} points='362.06 488.13 384.18 514.18 442.67 461.40 420.62 436.96 362.06 488.13' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-42' num={42} points='337.98 461.40 362.06 488.13 420.62 436.96 397.94 411.02 337.98 461.40' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-43' num={43} points='316.35 436.96 337.98 461.40 397.94 411.02 376.81 383.44 316.35 436.96' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-44' num={44} points='292.27 409.00 316.35 436.96 376.81 383.44 353.22 357.39 292.27 409.00' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-45' num={45} points='267.20 380.00 292.27 409.00 337.98 369.62 310.45 341.17 267.20 380.00' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-46' num={46} points='246.06 354.93 267.20 380.00 310.45 341.17 284.34 312.08 249.01 339.20 246.06 354.93' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-47' num={47} points='284.34 309.71 337.98 369.62 365.90 346.04 313.22 287.16 284.34 309.71' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='101-48' num={48} points='340.93 261.54 313.22 287.16 365.90 346.04 392.55 322.19 340.93 261.54' hov={hov} setHov={setHov} onClick={setModal}/>

        </svg>
      </div>
      {modal && <Modal lote={modal} onClose={()=>setModal(null)} onConsultar={handleConsultar}/>}
    </div>
  );
}
